import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { SmartphoneIcon, PlusIcon, ArrowRightIcon, CheckCircleIcon, XCircleIcon, ClockIcon, SearchIcon, RefreshCwIcon, DollarSignIcon, TrendingUpIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
const TradeIn = () => {
  const [activeTab, setActiveTab] = useState('active');
  const tradeInRequests = [{
    id: 1,
    customer: 'Alex Johnson',
    device: 'iPhone 13 Pro',
    condition: 'B',
    estimatedValue: '$520',
    status: 'Pending',
    date: '2023-07-20'
  }, {
    id: 2,
    customer: 'Maria Garcia',
    device: 'Samsung Galaxy S22',
    condition: 'A',
    estimatedValue: '$480',
    status: 'Approved',
    date: '2023-07-19'
  }, {
    id: 3,
    customer: 'James Wilson',
    device: 'Google Pixel 6',
    condition: 'C',
    estimatedValue: '$320',
    status: 'Rejected',
    date: '2023-07-18'
  }, {
    id: 4,
    customer: 'Sarah Miller',
    device: 'iPhone 12',
    condition: 'B',
    estimatedValue: '$350',
    status: 'Completed',
    date: '2023-07-15'
  }];
  const tradeInStats = {
    totalRequests: 48,
    pendingApproval: 12,
    approved: 8,
    completed: 24,
    averageValue: '$415'
  };
  return <div className="space-y-6" data-id="element-3411">
      <div className="flex items-center justify-between" data-id="element-3412">
        <div data-id="element-3413">
          <h1 className="text-2xl font-bold" data-id="element-3414">Trade-In Management</h1>
          <p className="text-sm text-muted-foreground" data-id="element-3415">
            Process device trade-ins, evaluate conditions, and manage customer
            offers
          </p>
        </div>
        <Button data-id="element-3416">
          <PlusIcon className="mr-2 h-4 w-4" data-id="element-3417" />
          New Trade-In
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3418">
        <Card data-id="element-3419">
          <CardContent className="p-4" data-id="element-3420">
            <div className="flex items-center justify-between" data-id="element-3421">
              <div data-id="element-3422">
                <p className="text-sm text-muted-foreground" data-id="element-3423">Total Requests</p>
                <p className="text-2xl font-bold" data-id="element-3424">
                  {tradeInStats.totalRequests}
                </p>
              </div>
              <RefreshCwIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3425" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-3426">
          <CardContent className="p-4" data-id="element-3427">
            <div className="flex items-center justify-between" data-id="element-3428">
              <div data-id="element-3429">
                <p className="text-sm text-muted-foreground" data-id="element-3430">
                  Pending Approval
                </p>
                <p className="text-2xl font-bold" data-id="element-3431">
                  {tradeInStats.pendingApproval}
                </p>
              </div>
              <ClockIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3432" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-3433">
          <CardContent className="p-4" data-id="element-3434">
            <div className="flex items-center justify-between" data-id="element-3435">
              <div data-id="element-3436">
                <p className="text-sm text-muted-foreground" data-id="element-3437">Completed</p>
                <p className="text-2xl font-bold" data-id="element-3438">{tradeInStats.completed}</p>
              </div>
              <CheckCircleIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3439" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-3440">
          <CardContent className="p-4" data-id="element-3441">
            <div className="flex items-center justify-between" data-id="element-3442">
              <div data-id="element-3443">
                <p className="text-sm text-muted-foreground" data-id="element-3444">Average Value</p>
                <p className="text-2xl font-bold" data-id="element-3445">
                  {tradeInStats.averageValue}
                </p>
              </div>
              <DollarSignIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-3446" />
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-3447">
        <CardHeader className="pb-2" data-id="element-3448">
          <div className="flex items-center justify-between" data-id="element-3449">
            <CardTitle data-id="element-3450">Trade-In Requests</CardTitle>
            <div className="relative" data-id="element-3451">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-3452" />
              <input type="text" placeholder="Search requests..." className="pl-10 pr-4 py-2 rounded-md border bg-background text-sm w-64" data-id="element-3453" />
            </div>
          </div>
          <CardDescription data-id="element-3454">
            Manage and process incoming trade-in requests
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-3455">
          <Tabs defaultValue="active" value={activeTab} onValueChange={setActiveTab} data-id="element-3456">
            <TabsList className="mb-4" data-id="element-3457">
              <TabsTrigger value="active" data-id="element-3458">Active Requests</TabsTrigger>
              <TabsTrigger value="completed" data-id="element-3459">Completed</TabsTrigger>
              <TabsTrigger value="rejected" data-id="element-3460">Rejected</TabsTrigger>
            </TabsList>
            <TabsContent value="active" className="space-y-4" data-id="element-3461">
              <div className="overflow-x-auto" data-id="element-3462">
                <table className="w-full" data-id="element-3463">
                  <thead data-id="element-3464">
                    <tr className="border-b" data-id="element-3465">
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3466">
                        Customer
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3467">
                        Device
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3468">
                        Condition
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3469">
                        Est. Value
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3470">
                        Status
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3471">
                        Date
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-3472">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-3473">
                    {tradeInRequests.filter(req => ['Pending', 'Approved'].includes(req.status)).map(request => <tr key={request.id} className="border-b hover:bg-muted/50" data-id="element-3474">
                          <td className="py-3 px-4 font-medium" data-id="element-3475">
                            {request.customer}
                          </td>
                          <td className="py-3 px-4" data-id="element-3476">{request.device}</td>
                          <td className="py-3 px-4" data-id="element-3477">
                            <Badge variant={request.condition === 'A' ? 'success' : request.condition === 'B' ? 'warning' : 'default'} data-id="element-3478">
                              {request.condition}
                            </Badge>
                          </td>
                          <td className="py-3 px-4 font-medium" data-id="element-3479">
                            {request.estimatedValue}
                          </td>
                          <td className="py-3 px-4" data-id="element-3480">
                            <Badge variant={request.status === 'Approved' ? 'success' : request.status === 'Pending' ? 'warning' : request.status === 'Rejected' ? 'destructive' : 'secondary'} data-id="element-3481">
                              {request.status}
                            </Badge>
                          </td>
                          <td className="py-3 px-4 text-sm" data-id="element-3482">{request.date}</td>
                          <td className="py-3 px-4" data-id="element-3483">
                            <div className="flex space-x-2" data-id="element-3484">
                              <Button variant="ghost" size="sm" data-id="element-3485">
                                View
                              </Button>
                              <Button variant="outline" size="sm" data-id="element-3486">
                                Process
                              </Button>
                            </div>
                          </td>
                        </tr>)}
                  </tbody>
                </table>
              </div>
            </TabsContent>
            <TabsContent value="completed" data-id="element-3487">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-3488">
                <p className="text-muted-foreground" data-id="element-3489">
                  Completed trade-ins will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="rejected" data-id="element-3490">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-3491">
                <p className="text-muted-foreground" data-id="element-3492">
                  Rejected trade-ins will be displayed here
                </p>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
      <Card data-id="element-3493">
        <CardHeader data-id="element-3494">
          <CardTitle data-id="element-3495">Quick Trade-In Estimator</CardTitle>
          <CardDescription data-id="element-3496">
            Get an instant estimate for any device
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-3497">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3498">
            <div className="space-y-2" data-id="element-3499">
              <label htmlFor="device-model" className="text-sm font-medium" data-id="element-3500">
                Device Model
              </label>
              <select id="device-model" className="w-full p-2 rounded-md border bg-background" data-id="element-3501">
                <option value="" data-id="element-3502">Select Model</option>
                <option value="iphone13" data-id="element-3503">iPhone 13</option>
                <option value="iphone13pro" data-id="element-3504">iPhone 13 Pro</option>
                <option value="iphone12" data-id="element-3505">iPhone 12</option>
                <option value="samsungs22" data-id="element-3506">Samsung Galaxy S22</option>
                <option value="pixel6" data-id="element-3507">Google Pixel 6</option>
              </select>
            </div>
            <div className="space-y-2" data-id="element-3508">
              <label htmlFor="device-condition" className="text-sm font-medium" data-id="element-3509">
                Condition
              </label>
              <select id="device-condition" className="w-full p-2 rounded-md border bg-background" data-id="element-3510">
                <option value="" data-id="element-3511">Select Condition</option>
                <option value="a" data-id="element-3512">A Grade (Excellent)</option>
                <option value="b" data-id="element-3513">B Grade (Good)</option>
                <option value="c" data-id="element-3514">C Grade (Fair)</option>
                <option value="d" data-id="element-3515">D Grade (Poor)</option>
              </select>
            </div>
            <div className="flex items-end" data-id="element-3516">
              <Button className="w-full" data-id="element-3517">
                Get Estimate <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-3518" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
};
export default TradeIn;